var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQlexTrilogyHeader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 186,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M195.599 0h21.148L20.199 725H0L195.599 0z",
    fill: "#ADDC9A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M216.6 0h21.148L40.933 725H20.148L216.6 0z",
    fill: "#6CC04A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M237.599 0h22.148L62.925 725h-22L237.6 0z",
    fill: "#7C02BB"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjYwIiBoZWlnaHQ9IjE4NiIgdmlld0JveD0iMCAwIDI2MCAxODYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xOTUuNTk5IDBIMjE2Ljc0N0wyMC4xOTg4IDcyNUgwTDE5NS41OTkgMFoiIGZpbGw9IiNBRERDOUEiLz4KPHBhdGggZD0iTTIxNi42IDBIMjM3Ljc0OEw0MC45MzMxIDcyNUgyMC4xNDc2TDIxNi42IDBaIiBmaWxsPSIjNkNDMDRBIi8+CjxwYXRoIGQ9Ik0yMzcuNTk5IDBIMjU5Ljc0N0w2Mi45MjUyIDcyNUg0MC45MjU0TDIzNy41OTkgMFoiIGZpbGw9IiM3QzAyQkIiLz4KPC9zdmc+Cg==";
export { SvgQlexTrilogyHeader as ReactComponent };